module.exports = __webpack_public_path__ + "img/medalha-municipio-dinamico.d63d26d4.jpg";